import '~/src/common/js/site';
import './minigames/index';
